module.exports = __webpack_public_path__ + "images/119_1024.jpg";